<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
    <rect x="10" y="7" width="23.6667" height="31" rx="2" stroke="#00529A" stroke-width="2"/>
    <rect x="14.5286" y="11.8272" width="1.01014" height="9.09128" stroke="#00529A" stroke-width="1.01014"/>
    <rect x="17.7611" y="15.8677" width="1.01014" height="5.05071" stroke="#00529A" stroke-width="1.01014"/>
    <rect x="20.9936" y="14.2515" width="1.01014" height="6.66694" stroke="#00529A" stroke-width="1.01014"/>
    <rect x="24.226" y="11.4231" width="1.01014" height="9.49534" stroke="#00529A" stroke-width="1.01014"/>
    <rect x="27.4585" y="19.1002" width="1.01014" height="1.81826" stroke="#00529A" stroke-width="1.01014"/>
    <path d="M15.0789 25.9737H29.1667" stroke="#00529A" stroke-width="2"/>
    <path d="M15.0789 29.6403H29.1667" stroke="#00529A" stroke-width="2"/>
    <path d="M15.0789 33.5H29.1667" stroke="#00529A" stroke-width="2"/>
  </svg>
</template>